import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { SUBTITLES } from '../../config/constants';
import css from './Video.module.scss'; // http://web.archive.org/web/20160117160743/http://screenfont.ca/learn
// 'descriptions' attr needed for muted, non-translatory, non-hard-of-hearing audiences
// 'captions' are intended for deaf and hard-of-hearing audiences.

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TrackDefault = function TrackDefault(_ref) {
  var kind = _ref.kind,
      label = _ref.label,
      src = _ref.src;
  return /*#__PURE__*/_jsx("track", {
    default: true,
    kind: kind,
    label: label,
    src: src,
    srcLang: "en"
  });
};

TrackDefault.defaultProps = {
  kind: 'captions',
  label: 'english_captions'
};
TrackDefault.propTypes = {
  kind: PropTypes.string,
  label: PropTypes.string,
  src: PropTypes.string.isRequired
};

var TrackSubtitles = function TrackSubtitles(_ref2) {
  var kind = _ref2.kind,
      label = _ref2.label,
      src = _ref2.src;
  return /*#__PURE__*/_jsx("track", {
    kind: kind,
    label: label,
    src: src,
    srcLang: "en"
  });
};

TrackSubtitles.defaultProps = {
  kind: 'subtitles',
  label: 'english_subtitles'
};
TrackSubtitles.propTypes = {
  kind: PropTypes.string,
  label: PropTypes.string,
  src: PropTypes.string.isRequired
};

var Video = function Video(_ref3) {
  var autoPlay = _ref3.autoPlay,
      className = _ref3.className,
      controls = _ref3.controls,
      controlsList = _ref3.controlsList,
      crossOrigin = _ref3.crossOrigin,
      loop = _ref3.loop,
      muted = _ref3.muted,
      playsInline = _ref3.playsInline,
      poster = _ref3.poster,
      preload = _ref3.preload,
      src = _ref3.src,
      type = _ref3.type,
      initialTrack = _ref3.track,
      videoRef = _ref3.videoRef;
  var ref = videoRef || /*#__PURE__*/React.createRef();
  var track = typeof initialTrack == 'string' ? {
    src: initialTrack
  } : initialTrack;
  var hasCustomSubtitles = track && track.src && track.src.length > 0; // Hide video subtitles by default

  useEffect(function () {
    if (!ref || !ref.current) {
      return;
    }

    for (var i = 0; i < ref.current.textTracks.length; i++) {
      // eslint-disable-line
      ref.current.textTracks[i].mode = 'hidden'; // eslint-disable-line
    }
  }, [ref]);
  return /*#__PURE__*/_jsxs("video", {
    autoPlay: autoPlay,
    className: cc([css.video, className]),
    controls: controls,
    controlsList: controlsList,
    crossOrigin: crossOrigin,
    loop: loop,
    muted: muted,
    poster: (poster === null || poster === void 0 ? void 0 : poster.src) || poster,
    playsInline: playsInline,
    preload: preload,
    ref: ref,
    children: [/*#__PURE__*/_jsx("source", {
      src: src,
      type: type
    }), !hasCustomSubtitles && muted && /*#__PURE__*/_jsx(TrackDefault, _objectSpread(_objectSpread({}, track), {}, {
      src: SUBTITLES
    })), hasCustomSubtitles && /*#__PURE__*/_jsx(TrackSubtitles, _objectSpread({}, track))]
  });
};

Video.defaultProps = {
  autoPlay: true,
  controls: false,
  className: '',
  controlsList: 'nodownload',
  crossOrigin: 'anonymous',
  loop: true,
  muted: true,
  playsInline: true,
  poster: '',
  preload: 'auto',
  type: 'video/mp4',
  track: null,
  videoRef: false
};
Video.propTypes = {
  autoPlay: PropTypes.bool,
  className: PropTypes.string,
  controls: PropTypes.bool,
  controlsList: PropTypes.string,
  crossOrigin: PropTypes.string,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  preload: PropTypes.string,
  playsInline: PropTypes.bool,
  poster: PropTypes.oneOfType([PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string
  }), PropTypes.string]),
  src: PropTypes.string.isRequired,
  type: PropTypes.string,
  track: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({}), PropTypes.string]),
  videoRef: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})])
};
export default Video;